


























import DateRange from './components/dateRange.vue';
import TextInput from './components/input.vue';
import SelectInput from './components/select.vue';

export enum FILTER_TYPES {
    SELECT,
    TEXT,
    DATERANGE,
}

export enum FILTER_VISIBILITY {
    DESKTOP = 999999999,
    TABLET = 1024,
    MOBILE = 768
}

export interface FilterItem {
    type: FILTER_TYPES;
    key: string;
    enabled: boolean;
    placeholder: string;
    options?: {
        value: string;
        label: string;
    }[];
    dates?: Date[];
    value?: string;
    hideOn?: FILTER_VISIBILITY[];
}

export default {
    data() {
        return {
            windowWidth: window.innerHeight,
            textModel: '',
            selectModel: [],
            types: FILTER_TYPES,
            savedFilters: [],
        };
    },
    props: ['filters', 'hasButtons', 'keepFilters', 'uniqueId', 'isVisible', 'inline'],
    mounted(this: any) {
        this.$nextTick(() => {
            window.addEventListener('resize', this.onResize);
        });

        this.savedFilters = this.filters;
        if (this.keepFilters) {
            this.enrichFilters();
            this.sendUpdate();
        }

        this.onResize();
    },
    beforeDestroy(this: any) {
        window.removeEventListener('resize', this.onResize);
    },
    computed: {
        activeFilters: {
            cache: false,
            get(this: any) {
                const items: any = this.savedFilters;
                const result: any = [];
                items.forEach((item: FilterItem) => {
                    if (item.value && this.isFilterVisible(item)) {
                        result.push(item);
                    }
                });

                return result;
            },
        },
    },
    methods: {
        resetFilter(this: any, key: string) {
            const filters = this.savedFilters.map(((item: FilterItem) => {
                if (item.key === key) {
                    item.value = '';
                }

                return item;
            }));
            this.savedFilters = filters;
            this.sendClick();
        },
        change(this: any, filter: FilterItem, value: any) {
            const currentFilter: FilterItem = this.savedFilters.find((item: FilterItem) => item.key === filter.key);
            if (currentFilter) {
                currentFilter.value = value;
            } else {
                console.log('Error in handling the filters', filter, value);
            }

            if (!this.hasButtons) {
                this.saveFiltersInMemory();
                this.sendUpdate();
            }
        },

        onResize(this: any) {
            this.windowWidth = window.innerWidth;
        },

        sendClick(this: any) {
            this.saveFiltersInMemory();
            this.sendUpdate();
        },

        sendUpdate(this: any) {
            this.$emit('change', this.savedFilters);
        },

        resetValues(this: any) {
            this.$refs.filterItem.forEach((item: any) => item.reset());
            this.savedFilters.forEach((item: any) => { item.value = ''; return undefined; });
            this.removeFilters();
            this.sendUpdate();
        },

        createKey(this: any, item: FilterItem) {
            return `filter_${item.key}_value`;
        },

        show(this: any) {
            this.isVisible = true;
        },

        hide(this: any) {
            this.isVisible = false;
        },

        isFilterVisible(this: any, filter: FilterItem) {
            if (Array.isArray(filter.hideOn) && filter.hideOn.length) {
                const visibility: boolean[] = filter.hideOn.map((hides: any) => {
                    switch (hides) {
                    case FILTER_VISIBILITY.DESKTOP:
                        return !(this.windowWidth >= FILTER_VISIBILITY.TABLET);
                    case FILTER_VISIBILITY.TABLET:
                        return !(this.windowWidth >= FILTER_VISIBILITY.MOBILE && this.windowWidth <= FILTER_VISIBILITY.TABLET);
                    case FILTER_VISIBILITY.MOBILE:
                        return !(this.windowWidth <= FILTER_VISIBILITY.MOBILE);
                    default:
                        return true;
                    }
                });

                return !visibility.includes(false);
            }

            return true;
        },

        saveFiltersInMemory(this: any) {
            if (this.keepFilters) {
                this.savedFilters.forEach((item: FilterItem) => {
                    if (item.value) {
                        localStorage.setItem(this.createKey(item), JSON.stringify(item.value));
                    } else {
                        localStorage.removeItem(this.createKey(item));
                    }
                });
            }
        },

        enrichFilters(this: any) {
            if (this.keepFilters) {
                this.savedFilters.forEach((item: FilterItem) => {
                    const value = localStorage.getItem(this.createKey(item));
                    if (value) {
                        item.value = JSON.parse(value);
                    }
                });
            }
        },

        removeFilters(this: any) {
            if (this.keepFilters) {
                this.savedFilters.forEach((item: FilterItem) => {
                    localStorage.removeItem(this.createKey(item));
                });
            }
        },
    },
    components: {
        DateRange,
        TextInput,
        SelectInput,
    },
};
